import { http } from '@/shared/http.ts'

export const getTotalAccountValueData = async () => {
  return await http.get<{ total_value: number }>('/analytics/account-value-total')
}


export const postCountClick = async (token: string, event_name: string) => {
  return await http.post(
    '/analytics/',
    {
      body: { event_name },
      token,
    },
  )
}
